import React from "react";
import { useParams, Link } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AppTable from "components/Shared/AppTable";
import { useGetCodTransferChargeDetailQuery } from "store/services/PaymentsApi/codTransferApi";

const CODChargeDeductReportDetailView = () => {
    const { id } = useParams();

    const { data, isLoading, isFetching, error } =
        useGetCodTransferChargeDetailQuery(id, { skip: !id });

    const shipments = data?.shipments || [];

    const columns = [
        {
            name: "Shipment ID",
            selector: (row) => row?.shipmentId,
            cell: (row) => row?.shipmentId || "N/A",
        },
        {
            name: "COD Amount",
            selector: (row) => row?.codAmount,
            cell: (row) => `Rs ${(row?.codAmount || 0).toFixed(2)}`,
            right: true,
        },
        {
            name: "Charge Amount",
            selector: (row) => row?.chargeAmount,
            cell: (row) => `Rs ${(row?.chargeAmount || 0).toFixed(2)}`,
            right: true,
        },
    ];

    const breadcrumbs = [
        { title: "Reports", path: "/app/crm/reports/list" },
        {
            title: "COD Service Charge Deduct Report",
            path: "/app/crm/reports/cod-charge-deduct-report",
        },
        { title: data?.codTransferId || "Detail" },
    ];

    return (
        <BreadcrumbLayout breadcrumbs={breadcrumbs}>
            <BreadcrumbLayout.Error error={error} />
            <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 2 }}>
                <Link to={-1}>
                    <ArrowBackIcon />
                </Link>
                <Typography variant="h6">
                    COD Transfer Charge Detail
                    {data?.codTransferId && ` - ${data.codTransferId}`}
                </Typography>
            </Box>

            {isLoading || isFetching ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <AppTable
                    columns={columns}
                    data={shipments}
                    progressPending={isLoading || isFetching}
                    pagination={false}
                />
            )}
        </BreadcrumbLayout>
    );
};

export default CODChargeDeductReportDetailView;